import { createIcon } from '../createIcon';
import { ReactComponent as IconListUl } from '../svg/list-ul.svg';

export default createIcon(IconListUl);
